module.exports = __webpack_public_path__ + "img/success.bc37d440.png";